<template>
  <div v-if="temps.length > 0" class="pg-multi-click-to-router-by-biz">
    <template v-for="(i, index) in temps">
      <PgClickToRouterByBiz
        class="pg-multi-click-to-router-by-biz_pointer"
        :key="index"
        :value="i.value"
        :routerQuery="i.routerQuery"
        :routerName="routerName"
      />
    </template>
  </div>
  <div v-else>-</div>
</template>
<script setup>
import PgClickToRouterByBiz from './click-to-router-by-biz.vue'
import { useMultiClickToRouterByBiz } from '../hooks/index'

const props = defineProps({
  value: [Array, String, Number],
  id: String,
  routerName: String,
})

const { temps } = useMultiClickToRouterByBiz({ props })
</script>

<style lang="scss">
@import '../style/multi-click-to-router-by-biz.scss';
</style>
